import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { faInfoCircle, faUsers, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { DirectionsService } from "../directions/services/directions.service";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    standalone: false
})
export class HomeComponent implements OnInit {

  faUsers = faUsers;
  faCalendarAlt = faCalendarAlt;
  faInfoCircle = faInfoCircle;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected service: DirectionsService
  ) { }

  ngOnInit() {
    this.service.getAllDirections().subscribe(); //preload and cache all directions
    }
  }
